export default __webpack_public_path__ + "static/media/round_filter_measurements.bd833002.jpg";